import { translate } from 'services/i18nService';

import diceIcon from './images/games/dice-icon-summer.png';
import kenoIcon from './images/games/keno-icon-summer.png';
import wheelIcon from './images/games/wheel-icon-summer.png';
import logoImage from './images/logo-summer.png';
import summerBackground from './images/tile-summer.png';
import tippingTier1Sound from './sounds/tipping/summer_tipping_tier_1.mp3';
import tippingTier2Sound from './sounds/tipping/summer_tipping_tier_2.mp3';
import tippingTier3Sound from './sounds/tipping/summer_tipping_tier_3.mp3';
import tippingTier4Sound from './sounds/tipping/summer_tipping_tier_4.mp3';
import styles from './SummerTheme.css';


const SLOGAN_TRANSLATE_KEY = 'campaigns.summer.token.heading';
const OFFER_TEXT = {
  ntp: 'campaigns.summer.token.ntp',
  rest: 'campaigns.summer.token.all',
};

function getOfferText(campaign: any) {
  if (window.hasPurchases === undefined) {
    return translate(OFFER_TEXT.rest);
  }

  if (window.hasPurchases) {
    return translate(OFFER_TEXT.rest);
  }

  return translate(OFFER_TEXT.ntp, { 0: campaign?.assets?.bonusTokenAmountPlaceholder || '' });
}

const getBuyTokensModalConfig = (campaign: any) => {
  return {
    cookieNamePrefix: campaign.activeCampaignName,
    titleClass: styles.tokenOfferTitle,
    headerClass: styles.buyTokensModalHeader,
    title: translate(SLOGAN_TRANSLATE_KEY, { 0: campaign.campaignDetails.bonusTokenPercent }),
    text: getOfferText(campaign),
  };
};

const getChatOfferConfig = (campaign: any) => {
  return {
    titleClass: styles.tokenOfferTitle,
    wrapperClass: styles.chatOfferWrapperClass,
    title: translate(SLOGAN_TRANSLATE_KEY, { 0: campaign.campaignDetails.bonusTokenPercent }),
    text: getOfferText(campaign),
  };
};

const getDrawerMenuConfig = (campaign: any) => {
  return {
    title: translate(SLOGAN_TRANSLATE_KEY, { 0: campaign.campaignDetails.bonusTokenPercent }),
    text: getOfferText(campaign),
    bodyClass: styles.drawerMenuContainer,
    titleClass: styles.drawerMenuTitle,
  };
};

const getGamesThemeConfig = () => {
  return {
    keno: {
      icon: kenoIcon,
      borderClass: styles.kenoBorder,
      containerClass: styles.kenoContainer,
    },
    wheel: {
      icon: wheelIcon,
      containerClass: styles.wheelContainer,
      outerCircleClass: styles.wheelOuterCircle,
      arrowClass: styles.wheelArrow,
      centerClass: styles.wheelCenter,
    },
    dice: {
      icon: diceIcon,
      containerClass: styles.diceContainer,
    },
  };
};

const getHeaderCTAConfig = (campaign: any) => {
  return {
    cookieNamePrefix: campaign.activeCampaignName,
    wrapperClass: styles.headerCTAWrapper,
    title: translate(SLOGAN_TRANSLATE_KEY, { 0: campaign.campaignDetails.bonusTokenPercent }),
  };
};

const getInfoStripConfig = (campaign: any) => {
  return {
    campaignSecondsLeft: campaign.campaignDetails.timeLeft,
    titleClass: styles.tokenOfferTitle,
    wrapperClass: styles.infoStripWrapperClass,
    title: translate(SLOGAN_TRANSLATE_KEY, { 0: campaign.campaignDetails.bonusTokenPercent }),
    text: getOfferText(campaign),
    useTimer: true,
  };
};

const getLogoThemeConfig = () => logoImage;

const getMobileOverlayConfig = (campaign: any) => {
  return {
    cookieNamePrefix: campaign.activeCampaignName,
    title: translate(SLOGAN_TRANSLATE_KEY, { 0: campaign.campaignDetails.bonusTokenPercent }),
    titleClass: styles.tokenOfferTitle,
    text: getOfferText(campaign),
    bodyClass: styles.mobileOverlayBody,
  };
};

const getOnCamAnimationConfig = (campaign: any) => {
  return {
    cookieNamePrefix: campaign.activeCampaignName,
    animBackgroundClass: styles.animBackground,
    animBackground2Class: styles.animBackground2,
    staticBackgroundClass: styles.staticBackground,
    animWrapperClass: styles.animWrapper,
    animTextClass: styles.animText,
    line1Text: translate(SLOGAN_TRANSLATE_KEY,
      { 0: campaign.campaignDetails.bonusTokenPercent }
    ),
  };
};

const getRegistrationOverlayConfig = (campaign: any) => {
  return {
    title: translate('campaigns.summer.registration.title'),
    text: translate('campaigns.summer.registration.text',
      {
        0: campaign.campaignDetails.bonusTokenPercent,
        1: '<i><u>',
        2: '</u></i>',
        3: campaign?.assets?.bonusTokenAmountPlaceholder || '',
      }
    ),
    titleClass: styles.registrationOverlayTitle,
    backgroundImage: summerBackground,
  };
};

const getTippingSoundsConfig = () => {
  return {
    tier1Sound: tippingTier1Sound,
    tier2Sound: tippingTier2Sound,
    tier3Sound: tippingTier3Sound,
    tier4Sound: tippingTier4Sound,
  };
};

export {
  getBuyTokensModalConfig,
  getChatOfferConfig,
  getDrawerMenuConfig,
  getGamesThemeConfig,
  getHeaderCTAConfig,
  getInfoStripConfig,
  getLogoThemeConfig,
  getMobileOverlayConfig,
  getOnCamAnimationConfig,
  getRegistrationOverlayConfig,
  getTippingSoundsConfig,
};
